<template>
  <div class="discussion">
    <div class="discussion-user">
      <img
        class="discussion-user-image"
        :src="discussionuser.body.user.picture.data.url"
        v-if="discussionuser && discussionuser.body && discussionuser.body.user && discussionuser.body.user.picture"
      />
      {{ discussionuser && discussionuser.body && discussionuser.body.user && discussionuser.body.user.name ? discussionuser.body.user.name : discussion.body.conversation.participants.data.find(participant => participant.username != page.name).username }}
    </div>
    <ul class="discussion-order scrollable">
      <li v-for="(discut, key) in discussion.body.discussion.data" :key="key">
        <div v-on:dblclick="reactToMessage(discut.id, discut)">
          <div v-if="discut.from.id != page.network_id" class="message-received">
            <div class="message-received-image">
              <img
                class="message-received-image"
                :src="discussionuser.body.user.picture.data.url"
                v-if="discussionuser && discussionuser.body && discussionuser.body.user && discussionuser.body.user.picture"
              />
              <span v-else-if="discut.from.username != page.name">{{ discut.from.name.charAt(0) }}</span>
            </div>
            <div class="message-received-content">
              <div
                v-bind:class="
                  getInstagram
                    ? 'message-received-content-text-instagram'
                    : 'message-received-content-text'
                "
              >
                {{ discut.message }}
                <div v-if="discut.attachments">
                  <img
                    class="message-received-content-image"
                    :src="discut.attachments.data[0].image_data.url"
                  />
                </div>
              </div>
              <div v-if="discut.reactions && page.network == 'instagram'">
                <div
                  v-if="discut.reactions.data[0].reaction == 'love'"
                  class="message-loved"
                >
                  <img
                    class="circle"
                    id="lovesvg"
                    src="../../assets/img/icon_heart_full_red.svg"
                  />
                </div>
              </div>
            </div>
          </div>

          <div v-if="discut.from.name == page.name" class="message-sent">
            <div class="message-sent-content">
              <div
                v-bind:class="
                  getInstagram
                    ? 'message-sent-content-text-instagram'
                    : 'message-sent-content-text'
                "
              >
                {{ discut.message }}
                <div v-if="discut.attachments">
                  <img
                    class="message-received-content-image"
                    v-if="
                      typeof discut.attachments.data[0].image_data !=
                      'undefined'
                    "
                    :src="discut.attachments.data[0].image_data.url"
                  />
                </div>
              </div>
              <div v-if="discut.reactions && page.network == 'instagram'">
                <div
                  v-if="discut.reactions.data[0].reaction == 'love'"
                  class="message-loved"
                >
                  <img
                    class="circle"
                    id="lovesvg"
                    src="../../assets/img/icon_heart_full_red.svg"
                  />
                </div>
              </div>
              <div
                v-if="
                  page.network == 'instagram' ||
                  (page.network == 'facebook' &&
                    discut.tags && discut.tags.data[2].name == 'sent')
                "
              >
                <img
                  class="message-sent-sended"
                  src="../../assets/img/icon_round_check.svg"
                />
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="discussion-preview-div" v-if="this.url.length != 0">
      <ul class="discussion-preview">
        <li v-for="(item, key) in url" :key="key">
          <img class="discussion-preview-image" :src="item" />
        </li>
      </ul>
      <button
        class="discussion-preview-delete"
        @click="clearInputFile"
      ></button>
    </div>

    <form
      id="send"
      @submit="onSubmitMessage"
      @keyup.enter="onSubmitMessage"
      method="post"
    >
      <div class="discussion-answer">
        <label class="uploadFile">
          <img src="../../assets/img/icon_paperclip.svg" />
          <input
            type="file"
            id="attachment"
            name="attachment"
            class="inputfile form-control"
            accept="video/*, image/*"
            @change="previewFiles"
          />
        </label>
        <!--@keyup.enter.native="onSubmitMessage"-->
        <div class="answear-zone">
          <div class="textarea-emoji-picker">
            <picker
              :data="emojiIndex"
              v-show="showEmojiPicker"
              title="Pick your emoji..."
              emoji="point_up"
              @select="addEmoji"
            />
            <span
              class="emoji-trigger"
              :class="{ triggered: showEmojiPicker }"
              @click="toggleEmojiPicker()"
            >
              <svg style="width: 20px; height: 20px" viewBox="0 0 24 24">
                <path
                  fill="#888888"
                  d="M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z"
                />
              </svg>
            </span>
            <vs-textarea
              id="textmessage"
              class="answer-text"
              height="80px"
              width="100%"
              v-model="message"
              ref="inputmessage"
            />
          </div>
        </div>

        <!-- <button type="submit" value="submit">Envoyer</button>     -->
      </div>
    </form>
  </div>

  <!-- savoir si c est un message recus ou envoyé  {{ discut.from.name }} {{ page.name }} sont egal. -->
</template>

<script>
import moment from 'moment'
import Moderation from './../mixins/Moderation'
import Form from '../auth/Form.vue'
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
import emojiData from '@/constants/emoji-mart-vue-fast/all.json'
import 'emoji-mart-vue-fast/css/emoji-mart.css'

export default {
  name: 'component-discussion',

  mixins: [Moderation],

  components: {
    Picker
  },

  props: {
    discussionuser: Object,
    page: Object,
    discussion: Object,
    attachment: Array,
    conversationName: String
  },

  data() {
    return {
      showEmojiPicker: false,
      emojiIndex: new EmojiIndex(emojiData),
      message: null,
      user: null,
      url: [],
      fileInput: [], // Store our uploaded file
      fileInputParesed: []
    }
  },

  async mounted() {
    //   let response = await this.getDiscussion(this.page, this.conversations)
    //  console.log(1, response)
    //  this.discussion = response.body.discussion
    // console.log(2, this.discussion.data)
  },

  methods: {
    onChange() {
      this.fileInput = [...this.$refs.file.files]
      console.log('this.$refs.file', this.$refs.file)
    },
    clearInputFile() {
      console.log(this.url)

      console.log('ici')
      console.log(document.getElementById('attachment').value)
      document.getElementById('attachment').value = ''
      this.url = []
    },
    previewFiles(e) {
      console.log('nombre d images', e.target.files.length)
      console.log(e.target.files)
      for (var file of e.target.files) {
        this.url.push(URL.createObjectURL(file))
      }
      console.log(this.url)
    },

    toggleEmojiPicker() {
      this.showEmojiPicker = !this.showEmojiPicker
      console.log('toggleemojipicker', this.showEmojiPicker)
    },

    hideEmojiPicker() {
      this.showEmojiPicker = false
    },
    addEmoji(emoji) {
      console.log('addemoji', this.message)
      const textarea = document.getElementById('textmessage')
      const cursorPosition = this.getInputSelection(textarea)
      this.message = this.message ? this.message : ''
      const start = this.message.substring(0, cursorPosition.start)
      const end = this.message.substring(cursorPosition.end)
      this.message = start + emoji.native + end
      console.log('emoji added:', this.message)
      textarea.focus()
      this.$nextTick(() => {
        textarea.selectionStart = (start + emoji.native).length
        textarea.selectionEnd = (start + emoji.native).length
      });
      this.hideEmojiPicker()
    },

    getInputSelection(el) {
      var start = 0,
        end = 0,
        normalizedValue,
        range,
        textInputRange,
        len,
        endRange

      if (
        typeof el.selectionStart == 'number' &&
        typeof el.selectionEnd == 'number'
      ) {
        start = el.selectionStart
        end = el.selectionEnd
      } else {
        range = document.selection.createRange()

        if (range && range.parentElement() == el) {
          len = el.value.length
          normalizedValue = el.value.replace(/\r\n/g, '\n')

          // Create a working TextRange that lives only in the input
          textInputRange = el.createTextRange()
          textInputRange.moveToBookmark(range.getBookmark())

          // Check if the start and end of the selection are at the very end
          // of the input, since moveStart/moveEnd doesn't return what we want
          // in those cases
          endRange = el.createTextRange()
          endRange.collapse(false)

          if (textInputRange.compareEndPoints('StartToEnd', endRange) > -1) {
            start = end = len
          } else {
            start = -textInputRange.moveStart('character', -len)
            start += normalizedValue.slice(0, start).split('\n').length - 1

            if (textInputRange.compareEndPoints('EndToEnd', endRange) > -1) {
              end = len
            } else {
              end = -textInputRange.moveEnd('character', -len)
              end += normalizedValue.slice(0, end).split('\n').length - 1
            }
          }
        }
      }

      return {
        start: start,
        end: end
      }
    },
    onSubmitMessage() {
      console.log('messagesubmitter')
      console.log(this.message)
      console.log('image:', document.getElementById('attachment').files[0])
      let file = document.getElementById('attachment').files[0]
      let formData = new FormData()
      formData.append('message', this.message)
      formData.append('file', file)
      // formData.append("file", this.url[0], "palmier")
      console.log('formdata')
      for (var value of formData.values()) {
        console.log('formdata', value)
      }
      this.$emit('messageSend', formData)
      this.message = null
      this.url = []
    },

    uploadFile(file) {
      const { VUE_APP_API_HOST } = process.env

      let formData = new FormData()
      formData.append('file', file)

      return this.$http
        .post(`${VUE_APP_API_HOST}/moderation/upload/file`, formData, {
          progress: (e) => {
            if (e.lengthComputable) {
              console.log(Math.floor((e.loaded / e.total) * 100))
              //  this.percentUpload = Math.floor(e.loaded / e.total * 100)
            }
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    dateFromNow(date) {
      return moment(date).fromNow()
    },
    reactToMessage(discussionid, discut) {
      if (this.page.network == 'instagram') {
        var react = true
        if (discut.reactions && discut.reactions.data[0].reaction == 'love')
          react = false
        this.$emit('reactToMessage', discussionid, react)
      }
    },

    dateFormat(date) {
      return moment(date).local(this.$i18n.locale).format('LLL')
    }

    //  async getConv(){
    //    console.log('entrer dans getConversations moderation',this.pagesActive[this.selectedTab])
    //    let status = await this.getConversations(this.pagesActive[this.selectedTab])
    //  },
  },

  computed: {
    getInstagram() {
      if (this.page.network == 'instagram') return true
      else return false
    }
  },

  watch: {}
}
</script>